import React, {Component} from 'react'
import ToolTip from './ToolTip'
import styled from '@emotion/styled'
import sv from '../../../../styles/styles'
import ReactHtmlParser from 'react-html-parser';
import {isMobile} from 'react-device-detect';
import {playerActions} from "../../../../_actions/player.actions";
import {__isAvailable} from "../../../../_helpers/commons/utility.helper";
import {connect} from "react-redux";

// STYLE ##########################################################

const ItemContainer = styled(`div`)`
  ${sv.box};
  height: 100%;
  position: relative;
`;

const GistContent = styled('div')`
  position: relative;
  z-index: ${props => props.zIndex};
`;

const StyledGistItem = styled(`div`)`
  ${sv.box};
  margin-top: ${props => props.top}px;
  margin-left: ${props => props.left}px;
  transition: all ease-out 0.1s;
  text-transform: capitalize;
  cursor: pointer;
`;

const StyledWord = styled(`div`)`
  margin-left: ${props => props.hasSecondary 
    ? ( ((props.secondaryText.length > 3) 
        ? (props.fontSize / 1.5) 
        : (props.secondaryText.length * props.fontSize / 6.0)
        ) + "px")
    : "0" };
  margin-top: ${props => props.hasSecondary ? ((props.fontSize / -5.0 + 3.5) + "px") : "0" };
  font-size: ${props => props.fontSize}px;
  font-weight: ${props => props.fontWeight};
  color: ${props => props.isActive ? sv.colors.cta : props.fontColor};
  cursor: pointer;
  user-select: none;
  line-height: 100%;
`;

// COMPONENT ##########################################################

let longPressTimeout;
let hoverTimeout;

class CloudItem extends Component {

  constructor(props) {
    super(props);
    this.getGistItemRect = this.getGistItemRect.bind(this);
  }

  state = {
    isHovered: false,
    showHoveredTip: false,
    showMobileTip: false,
    mobileTipIgnoreUp: false,
    isActive: false,          // when item is probed
    zIndex: 0,                // controls word visibility when hint shown
  };

  shouldComponentUpdate(nextProps, nextState, snapshot) {
    // re-render iff only state and props changes (avoids unnecessary re-render of components when video is playing)
    return nextProps !== this.props || nextState !== this.state;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if chapter size changes - close mobile tip and reset
    if (this.props.chapterWidth !== prevProps.chapterWidth) {
      this.closeMobileTip();
    }
  }

  componentWillUnmount() {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = undefined;
    }
    if (longPressTimeout) {
      clearTimeout(longPressTimeout);
      longPressTimeout = undefined;
    }
  }


  handleClick = (e) => {
    let {showMobileTip} = this.state;

    this.props.hideWordOnTimeline();
    this.props.playWord(this.calculatePlayTimeStamp(this.props.item));
    this.props.dispatchGistWordPlay(this.props.item.importance);

    if (showMobileTip) {
      this.closeMobileTip();
    }

    e.stopPropagation();
  };

  calculatePlayTimeStamp = (currItem) =>{
    const priorSeekLimit = 1;               // prior seek time in seconds
    // check for sentence start time
    return (__isAvailable(currItem.stime) && (currItem.stime > currItem.time - priorSeekLimit))
        ? currItem.stime                    // sentence start time is later then use sentence start time
        : (currItem.time - priorSeekLimit); // apply prior-seek
  };

  handleMouseEnter = () => {
    if (!isMobile && !this.state.showHoveredTip) {
      hoverTimeout = setTimeout(this.showDesktopTip, 750);
    }
    this.setState({isActive: true});
    this.props.showWordOnTimeline(this.props.item.time);
    this.props.onHintTextShown(true);
  };

  handleMouseLeave = () => {
    clearTimeout(hoverTimeout);
    this.setState({showHoveredTip: false, isActive: false});
    this.props.hideWordOnTimeline();
    this.props.onHintTextShown(false);
  };

  getGistItemRect() {
    if (this.itemElm) {
      return this.itemElm.getBoundingClientRect();
    }
  };

  handleTouchStart = () => {
    if (!this.state.showMobileTip) {
      clearTimeout(longPressTimeout);
      this.setState({isActive: true});
      longPressTimeout = setTimeout(this.showMobileTip, 500);
    }
  };

  handleTouchEnd = (e) => {
    clearTimeout(longPressTimeout);
    this.setState({isActive: false});
    if (this.state.mobileTipIgnoreUp) {
      e.stopPropagation && e.stopPropagation();
      e.preventDefault && e.preventDefault();

      this.setState({mobileTipIgnoreUp: false})
    }
  };

  showDesktopTip = () =>  {
    this.setState({showHoveredTip: true});
    this.props.dispatchGistHintShow();
  };

  showMobileTip = () => {
    this.props.onHintTextShown(true);
    this.props.setLockGist(true);
    this.props.showWordOnTimeline(this.props.item.time);
    this.props.dispatchGistHintShow();
    this.setState({showMobileTip: true, mobileTipIgnoreUp: true, zIndex: 1501, isActive: true});
  };

  closeMobileTip = () => {
    this.props.onHintTextShown(false);
    this.props.setLockGist(false);
    this.props.hideWordOnTimeline();
    this.setState({showMobileTip: false, zIndex: 0, isActive: false});
  };

  render() {

    const {item} = {...this.props};
    const {showHoveredTip, showMobileTip} = this.state;

    const isTierOne = item.tier === 1;
    const showTip = showHoveredTip || showMobileTip;
    const isItemActive = this.state.isActive || showTip;

    let textContent;
    let words = item.name.split(" ");
    if (words.length > 1) {
      let firstWords = words.slice(0, -1).join(" ");
      textContent = [
        <StyledWord key="secondary"
                             fontSize={item.secondaryFont.size}
                             fontWeight={item.secondaryFont.weight}
                             fontColor={item.secondaryFont.color}
                             isActive={isItemActive}
        >{firstWords}</StyledWord>,
        <StyledWord key="primary"
                    fontSize={item.font.size}
                    fontWeight={item.font.weight}
                    fontColor={item.font.color}
                    hasSecondary={true}
                    secondaryText={firstWords}
                    isActive={isItemActive}
        >{words[words.length - 1]}</StyledWord>
      ];
    } else {
      textContent = <StyledWord
          fontSize={item.font.size}
          fontWeight={item.font.weight}
          fontColor={item.font.color}
          isActive={isItemActive}
      >{words[0]}</StyledWord>
    }

    return (
      <ItemContainer>
        <StyledGistItem
          ref={elm => this.itemElm = elm}
          isTierOne={isTierOne}
          left={item.padding.left}
          top={item.padding.top}
          tier={item.tier}
          onMouseEnter={() => this.handleMouseEnter()}
          onMouseLeave={() => this.handleMouseLeave()}
          onTouchStart={() => this.handleTouchStart()}
          onTouchEnd={(e) => this.handleTouchEnd(e)}
        >
          <GistContent
              zIndex={this.state.zIndex}
              onClick={(e) => this.handleClick(e)}
          >
            {textContent}
          </GistContent>
          {showTip &&
            <ToolTip
              getGistPlayerRect={this.props.getGistPlayerRect}
              getGistItemRect={this.getGistItemRect}
              modal={isMobile}
              marginTop={item.padding.top}
              marginLeft={item.padding.left}
              onClickClose={this.closeMobileTip}
            >
              {ReactHtmlParser(item.tcontext)}
            </ToolTip>
          }
        </StyledGistItem>
      </ItemContainer>
    )
  }
}

function mapStateToProps() {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatchGistWordPlay      : (weight)  => dispatch( playerActions.onGistWordPlay(weight) ),
		dispatchGistHintShow      : ()        => dispatch( playerActions.onGistHintShow() ),
	}
}

const connectGistItem = connect(mapStateToProps, mapDispatchToProps) (CloudItem);
export default connectGistItem;
